<template>
    <div class="emptyCont flex-col flex-c flex-ac">
        <img src="@/assets/img/empty.png" alt="">
        <p>{{ text }}</p>
    </div>
</template>
<script setup>
import {
    defineProps,
} from "vue";
const props = defineProps({
    text: String,
});
</script>
<style lang="scss" scoped>
.emptyCont {
    height: 100%;
    width: 100%;

    img {
        width: 60px;
    }

    p {
        font-size: 14px;
        color: #838B98;
    }
}
</style>
